import { Form } from 'react-bootstrap';
import { CLIENT_TIME_FIELDS, CpsClientLogsResponse } from './cps-utils';
import { TimeInput } from './TimeInput';

interface ReadOnlyLineItemProps {
  log: CpsClientLogsResponse;
}

const ReadOnlyLineItem = ({ log }: ReadOnlyLineItemProps) => {
  const hoursToMinutes = (h: number) => Math.round(h * 60);

  return (
    <div className='cps-survey-line-item'>
      <div className='cps-line-cell cps-cell-client'>
        <Form.Control type='text' value={log.client?.name ?? ''} readOnly disabled />
      </div>
      <div className='cps-line-cell cps-cell-relationship'>
        <Form.Control type='text' value={log.relationship?.name ?? ''} readOnly disabled />
      </div>
      {CLIENT_TIME_FIELDS.map(field => (
        <div key={field} className='cps-line-cell cps-cell-time'>
          <TimeInput value={hoursToMinutes(log[field])} readOnly />
        </div>
      ))}
      <div className='cps-line-cell cps-cell-total'>
        <TimeInput value={hoursToMinutes(log.totalHours)} readOnly isTotal />
      </div>
      <div className='cps-line-cell cps-cell-actions' />
    </div>
  );
};

export { ReadOnlyLineItem };
